import { render } from "./new_dropzone.vue?vue&type=template&id=539a2e9d"
import script from "./new_dropzone.vue?vue&type=script&lang=js"
export * from "./new_dropzone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__